import { ModalAuth } from "../app/auth";

const ModalAuthPlugin = {
    install(Vue, options) {
        this.EventBus = new Vue();
        Vue.component('modal-auth', ModalAuth);
        Vue.prototype.$modalAuth = {
            show() {
                ModalAuthPlugin.EventBus.$emit('show');
            },
            hide() {
                ModalAuthPlugin.EventBus.$emit('hide');
            }
        }
    }
};

export default ModalAuthPlugin
